import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gtm from '../../utils/gtm';

export const AnalyticsContext = React.createContext({});

export function withAnalytics(WrappedComponent) {
  return function AnalyticsComponent(props) {
    return (
      <AnalyticsContext.Consumer>
        {
          analyticsImplementation => (
            <WrappedComponent
              {...props}
              googleAnalytics={analyticsImplementation}
            />
          )
        }
      </AnalyticsContext.Consumer>
    );
  };
}

export class AnalyticsProvider extends Component {
  googleAnalytics = {
    trackUIEvent: function trackUIEvent(hitType = '', action = '', label = '') {
      gtm.pushGTMEvent({
        event: 'UI Events',
        hitType,
        action,
        label
      });
    }
  }

  render() {
    const { children } = this.props;
    return (
      <AnalyticsContext.Provider value={this.googleAnalytics}>
        {children}
      </AnalyticsContext.Provider>
    );
  }
}

AnalyticsProvider.propTypes = {
  children: PropTypes.element.isRequired
};
